<script>
import PedalKnob from '../PedalKnob.vue';
import CcBadge from '../CcBadge.vue';

export default {
  components: { PedalKnob, CcBadge },
  props: {
    effect: {
      type: Object,
      required: true
    }
  }
}
</script>
<template>
  <div class="pedal-knobs">
    <CcBadge :effect="effect" param="flip">
      <PedalKnob
        label="Flip"
        tip="The CC value sent on alternating periods (odd cycles). The effect toggles between Flip and Flop on each period boundary."
        :value="effect.flip"
        @update:value="v => effect.flip = v"
        />
    </CcBadge>
    <CcBadge :effect="effect" param="flop">
      <PedalKnob
        label="Flop"
        tip="The CC value sent on alternating periods (even cycles). The effect toggles between Flip and Flop on each period boundary."
        :value="effect.flop"
        @update:value="v => effect.flop = v"
        />
    </CcBadge>
  </div>
</template>
